import React, { useState, useEffect } from 'react';
import { useRecoilValue } from 'recoil';
import { useLocation } from 'react-router-dom';
import { splitQuery } from '../../Shares/CommonUtil';
import { initUnity, setUnityMember } from '../../Utils/unityUtil';
import { InteriorItemAPI } from '../../Utils/Api/InteriorItemAPI';
import { cdnUrlConfig } from '../../Utils/atoms';

const EWeekConditionCD = {
	Past: 1,
	Present: 2,
	Future: 3,
};

/**
 * [6월 이벤트] 비글즈 1주년 기념 인테리어 아이템 구매 이벤트
 * @returns
 */
const InteriorItemDetail = () => {
	const cdnUrl = useRecoilValue(cdnUrlConfig);
	const IMG_URL = `${cdnUrl}/BigglzEvent`;

	// 주소에서 event_se 가져오기
	const { search } = useLocation();
	const querys = splitQuery(search);
	const event_se = querys['event_se'] ? querys['event_se'] : 0;
	const [member_se, setMemberSe] = useState(0);
	const [weeklyData, setweeklyData] = useState([]);

	useEffect(() => {
		// Unity에서 member_se 호출
		if (event_se > 0) {
			initUnity();
			setUnityMember(
				(member_se) => setMemberSe(member_se),
				(msg) => alert.error(msg)
			);
		}
	}, []);

	useEffect(() => {
		// GET 주차별 이벤트 참여 현황 API 호출
		if (member_se > 0) {
			InteriorItemAPI.GetInteriorItemPurchaseStatus(member_se).then(
				(response) => {
					const { status, data } = response;
					if (status === 200) {
						setweeklyData(data.datas);
					}
				}
			);
		}
	}, [member_se]);

	return (
		<div id='wrap'>
			<div className='container'>
				<div className='content Interior'>
					{/* 비주얼 */}
					<div className='visual'>
						<h1>
							<img
								src={`${IMG_URL}/images/interior-item-purchase/tit.png`}
								alt='비글즈 1주년기념 Event 인테리어 사면 하트가 팡팡팡!'
							/>
						</h1>
						<i></i>
					</div>

					{/* 경품소개 */}
					<div className='event-info product'>
						<div className='tit-area'>
							<h2>
								매주 인테리어 <strong>소품 5개</strong> 사고
								<br />
								최대{' '}
								<span>
									<i></i> 400
								</span>
								개까지
								<br />
								받아가세요!
							</h2>
						</div>
					</div>

					{/* 참여현황 */}
					<div className='event-info ing'>
						<div className='content'>
							<div className='tit-area'>
								<h2>참여현황</h2>
							</div>
							<p>인테리어 소품을 구매하고 이벤트 현황판을 확인해 보세요.</p>
							<ul>
								{weeklyData.length > 0 &&
									weeklyData.map((value, index) => (
										<li key={index}>
											<div className='week'>{index + 1}주차</div>
											{value.week_condition_cd === EWeekConditionCD.Past &&
												value.mission_complete_yn === true && (
													<div className='txt success'>
														미션 성공! 선물함을 확인하세요!
													</div>
												)}
											{value.week_condition_cd === EWeekConditionCD.Past &&
												value.mission_complete_yn === false && (
													<div className='txt fail'>
														아쉽지만 기회가 지나갔어요.
													</div>
												)}
											{value.week_condition_cd === EWeekConditionCD.Present && (
												<ol className='txt check'>
													<li className={value.total_cnt >= 1 ? 'on' : ''}>
														1개
													</li>{' '}
													<li className={value.total_cnt >= 2 ? 'on' : ''}>
														2개
													</li>
													<li className={value.total_cnt >= 3 ? 'on' : ''}>
														3개
													</li>
													<li className={value.total_cnt >= 4 ? 'on' : ''}>
														4개
													</li>
													<li className={value.total_cnt >= 5 ? 'on' : ''}>
														5개
													</li>
												</ol>
											)}
											{value.week_condition_cd === EWeekConditionCD.Future && (
												<div className='txt yet'>아직 오픈하기 전이예요.</div>
											)}
										</li>
									))}
							</ul>
						</div>
					</div>

					{/* 참여방법 */}
					<div className='event-info howto'>
						<div className='content'>
							<div className='tit-area'>
								<h2>참여방법</h2>
							</div>
							<ol>
								<li>
									매주 인테리어 아이템을 <strong>5개 이상</strong> 구매한다.
								</li>
								<li>
									미션 성공 후 ‘선물함’에서 하트 <strong>100개씩</strong> 획득!
								</li>
							</ol>
							<p>상품은 주차마다 종료 후 그 다음날 일괄 지급됩니다.</p>
						</div>
					</div>

					{/* 이벤트기간 */}
					<div className='event-info term'>
						<div className='content'>
							<div className='tit-area'>
								<h2>이벤트 기간</h2>
							</div>
							<p>2023년 06월 05일 (월) ~ 07월 02일 (일)</p>
						</div>
					</div>

					{/* 주의사항 */}
					<div className='cautionary'>
						<dl>
							<dt>확인해주세요</dt>
							<dd>
								이벤트 참여 및 보상 오류는 고객센터 1:1 로 문의주세요.
								<br />
								*비글즈 어플 &gt; 마이페이지 &gt; 설정 &gt; 고객센터 &gt; 1:1
								문의
							</dd>
							<dd>
								구매 외 다른 방법으로 얻은 인테리어 소품은 제외되어 계산됩니다.
								(ex. 선물상자)
							</dd>
							<dd>상품은 주차마다 종료 후 그 다음날 일괄 지급됩니다.</dd>
							<dd>해당 이벤트는 앱스토어와 무관합니다.</dd>
							<dd>
								당첨자는 펫룸 &gt; 알림 &gt; 선물함 &gt; ‘받기'를 통해서 상품을
								받으실 수 있습니다
							</dd>
							<dd>이벤트 기프티콘 상품은 교환/환불/연장이 불가합니다.</dd>
							<dd>
								지급된 상품은 30일 내로 ‘받기'를 해주셔야 정상 수령됩니다.
							</dd>
						</dl>
					</div>
				</div>
			</div>
		</div>
	);
};

export default InteriorItemDetail;
